import { Variants } from '../types/variant';

export const hepatoGastroVariants = {
  hepato_gastro_enterologie: {
    name: 'Hépato-gastro-entérologie',
    status: 'beta',
    description:
      'Questionnaire de préparation de consultation en hépato-gastro-entérologie. Couvre le contexte de consultation, le motif et les symptômes digestifs, puis les mensurations.',
    speciality: 'HEPATO-GASTRO-ENTEROLOGIE',
    patientOnboarding: 'DEFAULT',
    patientOffboarding: 'DEFAULT',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'GASTRO',
    initialQuestions: [],
    pages: {
      CONSULTATION: { title: 'Administratif', sections: ['CONTEXTE'] },
      COMPLAINTS: {
        title: 'Motifs',
        sections: [
          'MOTIF',
          'DOULEURS',
          'TRANSIT',
          'REFLUX',
          'ANUS',
          'FOIE',
          'SIGNES_GENERAUX',
        ],
      },
      MENSURATIONS: { title: 'Poids et taille', sections: ['MENSURATIONS'] },
      CONCLUSION: { title: 'Conclusion', sections: ['RECAP'] },
    },
    initialAssertions: [
      "[Message: #‹]-(06.a_lieu_emission)->[Lieu]-(01.DESCR)->[Salle d'Attente]-(PART_OF)->[Cabinet Médical: #c]",
      '[Médecin: #z‹]-(a_spécialité)->[Hépato-Gastro-Entérologie]',
    ],
    options: ['ALERTES'],
    visitMotivesSection: 'Motifs',
  },
} satisfies Variants;
